<template>
  <HMModalContainer :isStudioPage="true">
    <StudentLogin :onLoginFn="onLogin" />
  </HMModalContainer>
</template>

<script>
import StudentLogin from '@/web/components/signup/StudentLogin.vue';

export default {
  name: 'StudioLogin',
  components: {
    StudentLogin,
  },
  methods: {
    onLogin() {
      this.$router.push({ name: 'studio-dashboard' });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

::v-deep .login {
  .hm-modal-header {
    display: none !important;
  }
  @include media-breakpoint-up(sm) {
    h1 {
      margin-top: 0 !important;
    }
  }
}
</style>
